<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
        <div class="form-wrapper">
          <el-form
            :model="form"
            ref="ruleForm"
            class="flex flex-row w-full"
          >
          <div class="flex-1">

            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.type"
                prop="type"
                :options="tiposCertificadoForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="true"
                id-prefix="certificate"
                @change="onChangeType"
              >
                <template slot="label">{{$t('certificates.type_extend')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <div class="w-full">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="true"
                    id-prefix="certificate"
                  >
                    <template slot="label">{{$t('app.client')}}</template>
                  </AccessibleElSelect>
                </div>
                <base-button class="ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>
            <div>
              <div  class="lg:mb-2">
                <base-ro-input :label="$t('certificates.name')" :data="form.CommonName"/>
              </div>
              <div class="lg:mb-2">
                    <base-ro-input :label="$t('certificates.serial')" :data="form.HashPFX"/>
                  </div>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <base-ro-input :label="$t('certificates.expires_at')" :data="form.CertFechaCaducidad"/>
                </div>
              </div>
            </div>
          </div>
          </el-form>
        </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="trash"
            @click="deleteCertificate()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="restore"
            @click="restoreCertificate()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
        title="Borrar certificado"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-cert')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-cert">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template> 
      </BaseElDialog>
    </template>
  </detail-layout>
</template>

<script>
import { TIPOS_CERT } from '@/config/tipos-cert'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getCertificate } from '@/services/certificates/getCertificate'

import BaseElDialog from '@/components/base/BaseElDialog.vue'
import moment from 'moment'
import { getClients } from '@/services/clients/getClients'
import { deleteTrashCert } from '@/services/trash/deleteTrashCert'
import { restoreTrashCert } from '@/services/trash/restoreTrashCert'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-certificado',
  components: {
    BaseElDialog,
    DetailLayout,
    AccessibleElSelect
  },
  data: function () {
    return {
      loading: false,
      searchView: false,
      activeName: 'es',
      clientes: [],
      header: {
        title: ' DETALLE DE CERTIFICADO BORRADO',
        icon: 'certificates',
        breadcrumb: {},
        nav: [],
        url: 'trash/certificates'
      },
      file: {
        name: '',
        b64: ''
      },
      selectedCifs: [],
      cifHasCertif: false, // flag para indicar que se va a vincular un certificado a un cif que ya tiene otro certificado
      tiposCertificado: TIPOS_CERT,
      form: {
        type: 'pfx',
        CommonName: '',
        HashPFX: '',
        CertFechaCaducidad: '',
        file: '',
        password: '',
        clienteId: null,
        user: '',
        pass: '',
        id: 0
      },
      showModal: false,
      processMessageDelete: '¿Estás seguro que deseas borrar permanente el certificado?',
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    idEmpresa: function () {
      return this.$route.params.idEmpresa
    },
    serial: function () {
      return this.$route.params.serial
    },
    tipoCertificado: function () {
      return this.$route.params.tipo
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isAdmin: function () {
      return this.$store.getters['app/isAdmin']
    },
    tiposCertificadoForAccessibleSelect () {
      return this.tiposCertificado.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled
      }))
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        name: cliente.Nombre,
        value: cliente.IdEmpresa
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const idEmpresa = this.idEmpresa
    const serial = this.serial
    const tipoCert = this.tipoCertificado
    const breadcrumbs = []
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
    }
    await this.downloadData(idEmpresa, serial, tipoCert)
    
    breadcrumbs.push({ path: 'trash/certificates', name: this.$i18n.t('app.trash') })
    breadcrumbs.push({ path: 'trash/certificates', name: this.$i18n.t('trash.certificates') })
    this.form.name = serial
    breadcrumbs.push({ path: '', name: this.form.CommonName })
    this.$store.commit('app/setheaderBreadCrumb', this.form.CommonName)

    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    goDetailClient () {
      const id = this.idEmpresa
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteCertificate () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        const idEmpresa = this.idEmpresa
        const Serialnumber = this.serial
        const tipoCertificado = this.tipoCertificado
        payload.push({
          idEmpresa,
          Serialnumber,
          tipoCertificado
        })
        const response = await deleteTrashCert(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreCertificate: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        const idEmpresa = this.idEmpresa
        const Serialnumber = this.serial
        const tipoCertificado = this.tipoCertificado
        payload.push({
          idEmpresa,
          Serialnumber,
          tipoCertificado
        })
        const response = await restoreTrashCert(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    onChangeType: function (value) {
      // console.log('onChangeType', value)
    },
    watchFormHandler: function ({ CertFechaCaducidad }) {
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    goBack: function () {
      this.$router.push({ name: 'trash/certificates' })
    },
    downloadData: async function (idEmpresa, serial, tipoCertificado) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa,
          serial,
          tipoCertificado,
          borrado: true,
        }
        const data = await getCertificate(params)
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          this.setCertificate(data.Certificado)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCertificate: function (certificate) {
      this.form.HashPFX = certificate.HashPFX
      this.form.type = certificate.TipoCertificado
      this.form.CommonName = certificate.CommonName
      this.form.CertFechaCaducidad = moment(certificate.CertFechaCaducidad).format('DD-MM-yyyy HH:mm')
      this.form.clienteId = certificate.idEmpresa
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
  }

}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

 .el-loading-parent--relative {
    position: relative !important; }

  .el-loading-parent--hidden {
    overflow: hidden !important; }

    div.el-loading-mask {
        background-color: rgba(6,13,46,.8);
    }

  .el-loading-mask {
    position: absolute;
    z-index: 2000;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s; }
    .el-loading-mask.is-fullscreen {
      position: fixed; }
      .el-loading-mask.is-fullscreen .el-loading-spinner {
        margin-top: -25px; }
        .el-loading-mask.is-fullscreen .el-loading-spinner .circular {
          height: 50px;
          width: 50px; }
    div.el-loading-mask .el-loading-spinner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
body.el-loading-parent--relative {
    position: inherit !important;
}
  .el-loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute; }
    .el-loading-spinner .el-loading-text {
      color: #00BBFF;
      margin: 3px 0;
      font-size: 14px; }
    .el-loading-spinner .circular {
      height: 42px;
      width: 42px;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite; }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #00BBFF;
      stroke-linecap: round; }
    .el-loading-spinner i {
      color: #00BBFF; }

  .el-loading-fade-enter,
  .el-loading-fade-leave-active {
    opacity: 0; }
</style>

<style lang="sass" scoped>
</style>
